module.exports = __webpack_public_path__ + "img/raffle-wheel.24273d3e.png";